const buttonFilterUser = {
  label: 'filtros'
};

export default buttonFilterUser;
